import { FC } from 'react'
import FileChunksTable from 'src/components/molecules/chunks/FileChunksTable'

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface LibraryTabProps {}

export const LibraryTab: FC<LibraryTabProps> = () => {
  return (
    <div className={`my-6 flex flex-col gap-8 rounded-[8px] bg-gray-800 p-8`}>
      <FileChunksTable />
    </div>
  )
}
